import { Box, MenuItem, Select, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";
import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";

import profile_img from "../../../assets/avatar_placeholder.svg";
import filter_img from "../../../assets/Filter.png";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { cutString } from "../../../helpers";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import SessionBookingPopover from "../booking/SessionBookingPopover";
// import SessionBookingPopover from "./SessionBookingPopover";


export default function SessionPassBooking({
    bookingType = "teacherRecentBookings",
    navigation,
    classInfo,
    selectCustomerBooking,
    selectBuyingDetail
}) {
    const location = useLocation();
    const [userToken] = useLocalStorage("userToken");
    const userReduxState = useSelector(userState);
    const [bookingInfo, setBookingInfo] = React.useState();
    // const [anchorEl, setAnchorEl] = React.useState(null);

    const [listLoading, setListLoading] = React.useState(false);
    const [recentBookingsList, setRecentBookingsList] = React.useState([]);
    const [showViewMore, setShowViewMore] = React.useState(false);
    const [recentBookingsPageNumber, setRecentBookingsPageNumber] = React.useState(1);
    const [bookingFilter, setBookingFilter] = React.useState('all');

    const getRecentBookings = async (page = 1) => {
        // setShowViewMore(false);
        setListLoading(true);
        const manageClassesConfig = {
            method: "get",
            url: `${getUrlForBookings()}getMyPurchases?page=${page}&limit=2&filterBy=${bookingFilter}&classId=${classInfo.classId}&businessId=${classInfo.addedByUserId}&passId=${classInfo?.selectedPassDetail?.passId}&purchaseId=${selectBuyingDetail?._id}`,
            headers: {
                // "x-access-token": userToken,
            },
        };
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        if (manageClassesRequest.status === 200) {
            // console.log("manageClassesRequest.data.data.booking_detail", manageClassesRequest.data.data.booking_detail);
            if (manageClassesRequest.data.data.booking_detail.length) {
                // setShowViewMore(true);
                if (recentBookingsPageNumber > 1) {
                    setRecentBookingsList([...recentBookingsList, ...manageClassesRequest.data.data.booking_detail]);
                } else {
                    setRecentBookingsList(manageClassesRequest.data.data.booking_detail);
                }
            }
        }
        setListLoading(false);
    };

    const handleFilterChange = (event) => {
        const { target: { value } } = event;
        setRecentBookingsPageNumber(1)
        setBookingFilter(value);
        setRecentBookingsList([])
    };

    const ticketAmount = (row) => {
        if (row?.amount) {
            return parseFloat(row?.amount || 0).toFixed(2)
        } else {
            return row?.totalStripeAmount > 0 ? parseFloat(parseFloat(row.totalStripeAmount) + parseFloat(row.totalPaymentServiceFee)).toFixed(2) : "0"
        }
    }

    React.useEffect(() => {
        if (classInfo?.classId) {
            let filteredData = selectCustomerBooking
            if (bookingFilter !== "all") {
                filteredData = selectCustomerBooking.filter((d) => {
                    // console.log(d.status.toLowerCase() + "===" + bookingFilter);
                    return d.status.toLowerCase() === bookingFilter
                })
            }
            // console.log("filteredData", filteredData);
            setRecentBookingsList(filteredData);
            getRecentBookings(recentBookingsPageNumber)
        }
    }, [selectCustomerBooking, bookingFilter, classInfo]);

    React.useEffect(() => {
        getRecentBookings(recentBookingsPageNumber);
    }, [recentBookingsPageNumber, bookingFilter]);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            fontSize: 16,
            fontWeight: "bold",
            border: 0,
            padding: "0px 16px",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            color: "#464E5F",
            fontWeight: "bold",
            border: 0,
        },
        [`&.${tableCellClasses.body} > div`]: {
            // backgroundColor: "rgba(244, 244, 244, 0.4)",
            backgroundColor: "#fff",
            padding: "16px",
        },
        [`&.${tableCellClasses.body} div p`]: {
            fontSize: 11,
            color: "#B5B5C3",
            fontWeight: "500",
        },
        [`&:first-child div`]: {
            borderRadius: "12px 0 0 12px",
        },
        [`&:last-child div`]: {
            borderRadius: "0 12px 12px 0",
        },
        padding: "5px 0px 5px 0px",
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        // hide last border
        margin: "0px",
        border: 0,
        [`&:hover td div`]: {
            backgroundColor: "#F4F4F4",
        },
    }));

    return (
        <div
            className={`max-w-7xl min-h-[500px] px-5 py-2 pb-10 bg-white rounded-2xl mt-10`}
        >
            <div className={"flex flex-row justify-between items-center my-4"}>
                <div className={"flex flex-col"} style={{ flex: 1 }}>
                    <div className="flex justify-between">
                        <h3
                            className={
                                "text-black text-lg"
                            }
                        >
                            Bookings
                        </h3>
                        <Select
                            disableunderline={true}
                            MenuProps={{
                                sx: {
                                    "& .MuiMenu-paper": {
                                        border: 0,
                                    },
                                },
                            }}
                            sx={{
                                mr: 2,
                                '.MuiOutlinedInput-input': {
                                    borderWidth: 0,
                                    p: "0 !important",
                                },
                                '.MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderWidth: 0,
                                },
                            }}
                            IconComponent={null}
                            renderValue={(value) => (
                                <div className={"flex flex-row items-center gap-3"}>
                                    {value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                        return letter.toUpperCase();
                                    }) || ""}
                                    <img className="w-4" src={filter_img} alt={""} />
                                </div>
                            )}
                            value={bookingFilter}
                            onChange={handleFilterChange}
                        >
                            <MenuItem value={'all'}>All</MenuItem>
                            <MenuItem value={'confirmed'}>Confirmed</MenuItem>
                            <MenuItem value={'cancelled'}>Cancelled</MenuItem>
                            <MenuItem value={'refunded'}>Refunded</MenuItem>
                        </Select>
                    </div>
                    <p className="text-[10px] text-[#B5B5C3]"></p>
                </div>
            </div>
            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="center">CUSTOMER</StyledTableCell>
                            <StyledTableCell align="left">BOOKING ID</StyledTableCell>
                            <StyledTableCell align="left">ACTIVITY BOOKED</StyledTableCell>
                            <StyledTableCell align="left">SEATS BOOKED</StyledTableCell>
                            <StyledTableCell align="left">AMOUNT PAID</StyledTableCell>
                            <StyledTableCell width="10%" align="center"></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listLoading ? (
                            <StyledTableRow key={0} >
                                <StyledTableCell align="center" colSpan={6}>
                                    <Box className="rounded-2xl" sx={{ borderRadius: "12px !important" }}>
                                        <p>Loading...</p>
                                    </Box>
                                </StyledTableCell>
                            </StyledTableRow>
                        ) : (recentBookingsList.length ? recentBookingsList.map((row, i) => (
                            <StyledTableRow key={i} >
                                <StyledTableCell align="left">
                                    <Box>
                                        <Box className="flex justify-center items-center w-4/5">
                                            <Box className="flex-none">
                                                {row?.consumer_detail?.profilePic ? (<img
                                                    className="w-[33px] h-[33px] rounded-full mr-3"
                                                    src={row.consumer_detail.profilePic}
                                                    alt={``}
                                                />) : (<img
                                                    className="w-[33px] h-[33px] rounded-full mr-3"
                                                    src={profile_img}
                                                    alt={``}
                                                />)}
                                            </Box>
                                            <Box className=" p-0 w-28">
                                                <div>{cutString(row.studentName, 10, true)}</div>
                                                <div className="text-indigo-bz">{cutString((row.consumer_detail?.countryCode ? row.consumer_detail.countryCode + "_" + row.consumer_detail.phoneNumber : "" + row?.consumer_detail?.username), 10, true)}</div>
                                            </Box>
                                        </Box>

                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <Box>
                                        {row.bookingId}
                                        <p><span className={`${(row.status === "Cancelled") ? "text-bz-status-red" : "text-bz-status-green"}`}>{row.status}</span> | {format(parseISO(row.bookingDate), "MMM d")}</p>
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <Box>
                                        {row.className}
                                        <p>{row.schedule_class_detail && row.schedule_class_detail.classDate ? format(parseISO(row.schedule_class_detail.classDate), "MMM d") : ""}</p>
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <Box>
                                        {row.bookingQty ? row.bookingQty : "1"}
                                        <p title={row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                            return ticket.bookingQty + " x " + ticket.ticketType + " "
                                        }).join(" | ") : ""}>
                                            {cutString(row?.ticketsBought ? row.ticketsBought.map((ticket, i) => {
                                                return ticket.bookingQty + " x " + ticket.ticketType + " "
                                            }).join(" | ") : "", 25, true)}

                                        </p>
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <Box>
                                        €{ticketAmount(row)}
                                        <p>{(row.paymentStatus.toLowerCase() === "paid") ? "Paid Online" : row.paymentStatus}</p>
                                    </Box>
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    <Box>
                                        <SessionBookingPopover
                                            bookingType={bookingType}
                                            bookingDetails={row}
                                            handleUpdate={() => {
                                                getRecentBookings()
                                            }}
                                        />
                                    </Box>
                                </StyledTableCell>
                            </StyledTableRow>
                        )) : (
                            <StyledTableRow key={0} >
                                <StyledTableCell align="center" colSpan={6}>
                                    <Box className="rounded-2xl" sx={{ borderRadius: "12px !important" }}>
                                        <p>There is no bookings</p>
                                    </Box>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {showViewMore ? (<div className={"flex flex-row justify-center my-4"}>
                <button
                    className={
                        "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                    }
                    onClick={() => {
                        setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
                    }}
                >
                    View More
                </button>
            </div>) : ""}
        </div>
    );
}
